
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/legal-judicial-advocacy/named-party",
      function () {
        return require("private-next-pages/advocacy/legal-judicial-advocacy/named-party/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/legal-judicial-advocacy/named-party"])
      });
    }
  